import { TThunkAction } from '../../types/redux';
import {
  fetchExistsUserEstimationScoreFact,
  TExistsUserEstimationScoreFactResponse
} from '../../repositories/price-estimator/v1/exists-user-estimation-score-fact';
import { setRateOurEstimationScreen, setRateOurIsScoreFact, toggleRateOurEstimationLoadingBlock } from './actions';
import { BadRequestError } from '@cian/valuation-utils-component';
import { ERateScreen } from '../../types/redux/rateOurEstimation';
import {
  fetchPublicSuburbanV1ExistsUserEstimationScoreFact,
  TPublicSuburbanV1ExistsUserEstimationScoreFactResponse
} from '../../repositories/price-estimator/suburban/v1/exists-user-estimation-score-fact';
import { ECategory } from '../../../shared/repositories/price-estimator/entities/estimation_suburban_score_fact/EstimationSuburbanScoreSchema';

export function checkExistRateOurEstimation(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { area, roomsCount, houseId },
      page: { dealType },
    } = getState();
    const { httpApi, logger } = context;

    if (!area || !roomsCount || !houseId) {
      return;
    }

    dispatch(toggleRateOurEstimationLoadingBlock(true));
    dispatch(setRateOurEstimationScreen(ERateScreen.Form));

    const parameters = {
      area,
      roomsCount,
      houseId,
      dealType,
    };

    try {
      const res = (await fetchExistsUserEstimationScoreFact({
        httpApi,
        parameters,
      })) as TExistsUserEstimationScoreFactResponse;

      if (res.statusCode === 200) {
        dispatch(setRateOurIsScoreFact(res.response.exists));

        return;
      }

      throw new BadRequestError({
        domain: 'checkExistRateOurEstimation.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      logger.error(error, {
        message: 'Failed get price-estimator/v1/exists-user-estimation-score-fact',
        ...parameters,
      });
    } finally {
      dispatch(toggleRateOurEstimationLoadingBlock(false));
    }
  };
}

export function checkSuburbanExistRateOurEstimation(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { address, category, landArea, houseArea, houseId },
    } = getState();
    const { httpApi, logger } = context;

    dispatch(toggleRateOurEstimationLoadingBlock(true));
    dispatch(setRateOurEstimationScreen(ERateScreen.Form));

    const parameters = {
      address,
      category: category as unknown as ECategory,
      houseArea,
      houseId,
      landArea: landArea as number,
    };

    try {
      const res = (await fetchPublicSuburbanV1ExistsUserEstimationScoreFact({
        httpApi,
        parameters,
      })) as TPublicSuburbanV1ExistsUserEstimationScoreFactResponse;

      if (res.statusCode === 200) {
        dispatch(setRateOurIsScoreFact(res.response.exists));

        return;
      }

      throw new BadRequestError({
        domain: 'checkSuburbanExistRateOurEstimation.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      logger.error(error, {
        message: 'Failed get price-estimator/suburban/v1/exists-user-estimation-score-fact/',
        ...parameters,
      });
    } finally {
      dispatch(toggleRateOurEstimationLoadingBlock(false));
    }
  };
}
